import { useState, useEffect } from "react";

export default function useFetch(url) {
  const [data, setData] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsPending(true);
    setData(null);
    setError(null);
    const ab = new AbortController();
    fetch(url, {
      method: "GET",
      signal: ab.signal,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw Error("Error Fetching Data");
        }
        return res.json();
      })
      .then((result) => {
        setData(result.data);
        setIsPending(false);
        setError(null);
      })
      .catch((err) => {
        setIsPending(false);
        setData(null);
        setError(err);
      });

    return () => {
      ab.abort();
    };
  }, [url]);

  return [data, isPending, error];
}
